import { Link } from 'react-router-dom';

import { BulbOutlined, HomeOutlined, SettingOutlined, BarChartOutlined } from '@ant-design/icons';
import { MenuProps } from 'antd';
import { ClinicRoutes, PatientRoutes, routes, Routes } from 'routes';

import { menuIconStyle } from './menu-icon-style';

import { PlusCircleOutlined } from '@ant-design/icons';
import { MenuItemType } from 'antd/lib/menu/interface';
import { ReactComponent as RxSidemenuSummaryLogo } from 'img/rx-sidemenu-summary.svg';
import { ReactComponent as RxSidemenuTreatmentLogo } from 'img/rx-sidemenu-treatment.svg';
import { PatientRoutePattern } from 'navigation/router/route-switch/route-switch-patient/utils/patient-route-helpers';
import React from 'react';
import { theme } from 'styles/colors';
import { CRxAgentButtonWithContext } from './CRxAgentButton';
import { PatientLink } from './PatientLink';

export type MenuItem = Required<MenuProps>['items'][number];

export const MENUITEMS_GLOBALADMIN: MenuItem[] = [
  {
    key: routes.admin.organisationManagement,
    label: (
      <Link to={routes.admin.organisationManagement}>
        Organization Management
      </Link>
    ),
    icon: <PlusCircleOutlined style={{ color: theme.grey.medium }} />
  },
  {
    key: routes.admin.clinicSignupLinkGeneration,
    label: (
      <Link to={routes.admin.clinicSignupLinkGeneration}>
        Organization Signup Link Generator
      </Link>
    ),
    icon: <PlusCircleOutlined style={{ color: theme.grey.medium }} />
  }
];

export const MENUITEMS_CLINICADMIN: MenuItem[] = [
  {
    key: ClinicRoutes.ClinicUserManagement,
    label: <Link to={ClinicRoutes.ClinicUserManagement}>User Management</Link>,
    icon: <PlusCircleOutlined style={{ color: theme.grey.medium }} />
  },
  {
    key: ClinicRoutes.ClinicInfoEdit,
    label: <Link to={ClinicRoutes.ClinicInfoEdit}>Organization Info</Link>,
    icon: <PlusCircleOutlined style={{ color: theme.grey.medium }} />
  },
  {
    key: ClinicRoutes.ClinicBillingOrganisationUsage,
    label: (
      <Link to={ClinicRoutes.ClinicBillingOrganisationUsage}>
        Product Usage
      </Link>
    ),
    icon: <BarChartOutlined style={{ color: theme.grey.medium }} />
  },
  {
    key: ClinicRoutes.ClinicBillingSettings,
    label: (
      <Link to={ClinicRoutes.ClinicBillingSettings}>
        Billing Settings
      </Link>
    ),
    icon: <SettingOutlined style={{ color: theme.grey.medium }} />
  }
];

export const MENUITEMS_CLINICIAN_GENERAL: MenuItem[] = [
  // {
  //   key: ClinicRoutes.CrxCompanion,
  //   label: <Link to={ClinicRoutes.CrxCompanion}>CRx Companion</Link>,
  //   icon: <RxSidemenuTreatmentLogo style={menuIconStyle} />
  // },
  {
    key: Routes.ClinicianHome,
    label: <Link to={Routes.ClinicianHome}>Home</Link>,
    icon: <HomeOutlined style={{ color: theme.grey.medium }} />
  }
  // {
  //   key: 'general2',
  //   className: 'crx-agent-menu-item',
  //   label: <CRxAgentButton patientId={null} />,
  //   title: 'Oliver AI',
  //   icon: <BulbOutlined style={{ color: theme.grey.medium }} />
  // }
];

export const MENU_CLINICIAN_PATIENT: MenuItem[] = [
  createPatientMenuItem({
    route: PatientRoutePattern + routes.clinician.patient.assessments,
    text: 'Assessments',
    icon: <RxSidemenuTreatmentLogo style={menuIconStyle} />
  }),
  createPatientMenuItem({
    route: PatientRoutePattern + PatientRoutes.PatientDashboard,
    text: 'Dashboard',
    icon: <RxSidemenuSummaryLogo style={menuIconStyle} />
  }),
  // createPatientMenuItem({
  //   route: PatientRoutePattern + PatientRoutes.PatientTreatmentRecommendations,
  //   text: 'Recommended Treatment',
  //   icon: <RxSidemenuTreatmentLogo style={menuIconStyle} />
  // }),
  // createPatientMenuItem({
  //   route:
  //     PatientRoutePattern + PatientRoutes.PatientTreatmentRecommendationsV2,
  //   text: 'V2 Recommended Treatment',
  //   icon: <RxSidemenuTreatmentLogo style={menuIconStyle} />
  // }),
  // createPatientMenuItem({
  //   route: PatientRoutePattern + PatientRoutes.PatientSubtypeRange,
  //   text: 'Subtype Range',
  //   icon: <RxSidemenuTreatmentLogo style={menuIconStyle} />
  // }),
  createPatientMenuItem({
    route: PatientRoutePattern + PatientRoutes.PatientInventoryItemAnalysis,
    text: 'Inventory Analysis',
    icon: <RxSidemenuTreatmentLogo style={menuIconStyle} />
  }),
  {
    key: 'general2',
    className: 'crx-agent-menu-item',
    label: <CRxAgentButtonWithContext />,
    title: 'Oliver AI',
    icon: <BulbOutlined style={{ color: theme.grey.medium }} />
  }
];

function createPatientMenuItem(args: {
  route: string;
  text: string;
  icon: React.ReactNode;
  disabled?: boolean;
}): MenuItemType {
  return {
    key: args.route,
    label: <PatientLink to={args.route} text={args.text} />,
    icon: args.icon,
    disabled: args.disabled
  };
}
